<style lang="scss" scoped>
.sidebar {
    width: 300px;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-flow: column;
    padding: 60px 0;
    position: relative;
    background-image: linear-gradient(
        180deg,
        var(--primary) 0%,
        var(--primary-dark) 100%
    );
    z-index: 11;
    @media only screen and (min-width: 600px) and (max-width: 1025px) {
        position: absolute;
        right: 0;
        transition: right 0.3s;
        padding: 30px 0;
        &.closed {
            right: -290px;
        }
        .slideout {
            display: flex !important;
            background: #1f518c;
            position: absolute;
            top: 110px;
            left: -10px;
            border-radius: 20px 0 0 20px;
            width: 20px;
            height: 30px;
            z-index: -1;
            padding-left: 5px;
            cursor: pointer;
        }
    }
    .slideout {
        display: none;
    }
    .chart-container {
        position: relative;
        .chart-border-bottom {
            height: 1px;
            width: 100%;
            position: absolute;
            background: #fff;
            top: 185px;
        }
    }
    .sidebar-line {
        height: 1px;
        background: #fff;
        width: calc(100% - 64px);
        margin: 60px auto 40px auto;
        opacity: 0.5;
    }
    .sidebar-item {
        color: #fff;
        text-align: center;
        margin: 23px 0;
        &.active {
            font-weight: 700;
        }
    }
}
</style>

<template>
    <div class="sidebar" :class="{ closed : closed }">
        <div class="slideout" @click="() => { closed = !closed }">
            <i-back class="i-8 fill-white my-auto c-pointer"></i-back>
        </div>
        <div class="avatar mb-32 mb-lg-16 mb-xl-32 text-avatar mx-auto flex-none">
            <span>{{ currentUser.first_name.charAt(0) }} {{ currentUser.last_name.charAt(0) }}</span>
        </div>
        <p class="text-white text-center fw-b">{{ $t('sidebar.hello-user', { user : currentUser.first_name }) }}</p>

        <slot>

        </slot>

    </div>
</template>

<script>
export default {
    data: () => ({
        closed: true
    }),
    computed: {
        currentUser() {
            return this.$store.getters['user/currentUser']
        }
    }
}
</script>
  